import React, { useEffect, useMemo, useRef, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { apiError, daysAgo, today } from "../kits/shared";
import FiltrosTienda, { FILTRO_VACIO, FiltroTienda, fechasDe } from "./filtrosTienda";
import { Chip, Sub, monto } from "./piezasTienda";

/*
	Ventas › Margen (solo quien tiene Márgenes, 63; Módulos Claros 2026-11-01): las ventas con pérdida o con margen menor a 20 %,
	el mismo reporte de Márgenes (/productMargins/_sales). Márgenes sigue en el menú hasta la Fase 2.
*/

const BASE: FiltroTienda = { ...FILTRO_VACIO, preset: "rango", from: daysAgo(90), to: today() };

const TabMargen: React.FC<{ campusId: number; sym: string; movil: boolean; q: string }> = ({ campusId, sym, movil, q }) => {
	const [banda, setBanda] = useState<"loss" | "low">("loss");
	const [filtro, setFiltro] = useState<FiltroTienda>(BASE);
	const [data, setData] = useState<any | null>(null);
	const [error, setError] = useState<string | null>(null);
	const requestRef = useRef<number>(0);
	useEffect(() => {
		const request = ++requestRef.current;
		setData(null);
		setError(null);
		const { from, to } = fechasDe(filtro);
		HttpManager.getInstance().inventoryService.marginSales(campusId, { from, to, band: banda })
			.then((r) => { if (request === requestRef.current) setData(r.data); })
			.catch((e) => { if (request === requestRef.current) setError(apiError(e, "No se pudo cargar.")); });
	}, [campusId, banda, filtro]);

	const sinAcentos = (s: string) => (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
	const filas = useMemo(() => (data?.rows || []).filter((r: any) => !q || sinAcentos(r.student + " " + r.product).includes(sinAcentos(q))), [data, q]);
	const pct = (v: number | null) => v === null || v === undefined ? "-" : (v * 100).toLocaleString("es-MX", { maximumFractionDigits: 1 }) + " %";
	const cuenta = data?.counts || {};

	const lista = () => {
		if (!data) return error ? null : <div className="loader" />;
		if (filas.length < 1) return <div className="wvtSub" style={{ textAlign: "center", padding: 24, fontSize: 15 }}>{banda === "loss" ? "Ninguna venta con pérdida en estas fechas." : "Ninguna venta con margen menor a 20 % en estas fechas."}</div>;
		if (movil) return <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingBottom: 8 }}>
			{filas.map((r: any) => <div key={r.kitId} className="wvtTarjeta" style={{ cursor: "default" }}>
				<div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}><b>{r.product}{r.quantity > 1 ? " × " + r.quantity : ""}</b><Chip tono="oro">{pct(r.marginPct)}</Chip></div>
				<Sub>{r.student}, {r.date}</Sub>
				<div style={{ fontSize: 14 }}>Cobrado {monto(sym, r.revenue)} · Costo {monto(sym, r.cost)}</div>
			</div>)}
		</div>;
		return <table className="table wvtLista">
			<thead><tr><th style={{ width: 100 }}>Vendido</th><th>Alumna</th><th>Producto</th><th className="wvtNum">Cobrado</th><th className="wvtNum">Costo</th><th className="wvtNum">Margen</th><th className="wvtNum">%</th></tr></thead>
			<tbody>{filas.map((r: any) => <tr key={r.kitId}>
				<td style={{ whiteSpace: "nowrap" }}>{r.date}</td>
				<td>{r.student}</td>
				<td><b>{r.product}{r.quantity > 1 ? " × " + r.quantity : ""}</b><Sub>{r.waCode}</Sub></td>
				<td className="wvtNum">{monto(sym, r.revenue)}{r.discount > 0 ? <Sub>Lista {monto(sym, r.listPrice)}</Sub> : null}</td>
				<td className="wvtNum">{monto(sym, r.cost)}<Sub>{r.costSource}</Sub></td>
				<td className="wvtNum wvtOro">{monto(sym, r.margin)}</td>
				<td className="wvtNum"><Chip tono="oro">{pct(r.marginPct)}</Chip></td>
			</tr>)}</tbody>
		</table>;
	};

	return <>
		<FiltrosTienda valor={filtro} onChange={setFiltro} opciones={null} base={BASE} etiquetaFecha="Vendidas" antes={<div className="waFmSegs" style={{ marginRight: 14 }}>
				<button type="button" className={"waFmSeg" + (banda === "loss" ? " activo" : "")} onClick={() => setBanda("loss")}>Con Pérdida{cuenta.loss ? " " + cuenta.loss : ""}</button>
				<button type="button" className={"waFmSeg" + (banda === "low" ? " activo" : "")} onClick={() => setBanda("low")}>Margen Menor a 20 %{cuenta.low ? " " + cuenta.low : ""}</button>
		</div>} />
		{error ? <div className="alert alert-danger" style={{ marginTop: 12 }}>{error}</div> : null}
		<div className="waScrollX" style={{ overflowX: "auto", marginTop: 14, paddingBottom: 8 }}>{lista()}</div>
	</>;
};

export default TabMargen;
